import { render, staticRenderFns } from "./famCseg.vue?vue&type=template&id=3bfa4ac8&scoped=true"
import script from "./famCseg.vue?vue&type=script&lang=js"
export * from "./famCseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa4ac8",
  null
  
)

export default component.exports